import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, tap } from 'rxjs/operators';

import { getUserName } from '@digital-platform/ries-hub-shared/domain';
import { LoginSession } from '@digital-platform/users/domain';
import { LoginSessionFacadeService } from '@digital-platform/users/services';

@Component({
  selector: 'digital-platform-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent {
  public loggedIn$: Observable<boolean>;
  public emailVerified$: Observable<boolean>;
  public expanded = true;
  public userName: string;
  public isCustomer = false;
  public isScaleHouseUser = false;
  public isDashboardLinkVisible = true;

  private scaleHousePermissions = [
    'get:waste_profile',
    'review:manifest',
    'upload:manifest',
    'view:contact_us',
    'view:manifest',
  ];

  private currentUrl: string;
  private blackList: string[] = [
    '/login',
    '/forgot-password',
    '/create-account',
  ];

  @Output() $adjustFlex = new EventEmitter<boolean>();

  constructor(
    private loginSessionFacade: LoginSessionFacadeService,
    private router: Router
  ) {
    this.loggedIn$ = this.loginSessionFacade.loginSession$.pipe(
      map((loginSession) => {
        let loggedIn = true;
        if (loginSession === null || loginSession?.user === null) {
          loggedIn = false;
        } else if (loginSession?.user?.requirePasswordReset) {
          loggedIn = false;
        } else {
          this.userName = getUserName(loginSession?.user);

          this.isCustomer =
            loginSession?.user?.roles?.includes('Customer') || false;
        }
        return loggedIn;
      }),
      shareReplay(1)
    );
    this.loggedIn$.subscribe();

    // Keep track of current url so we can use when determining visibility of sidebar.
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((e: RouterEvent) => {
        this.currentUrl = e.url;
      });

    this.emailVerified$ = this.loginSessionFacade.loginSession$.pipe(
      tap((loginSession) => {
        this.isScaleHouseUser = this.hasScaleHousePermissions(loginSession);
        this.isDashboardLinkVisible =
          this.isScaleHouseUser === true ? false : true;
      }),
      map((loginSession) => loginSession?.user?.emailVerified || false),
      shareReplay(1)
    );
  }

  private hasScaleHousePermissions(session: LoginSession): boolean {
    if (!session || !session.user || !session.user.permissions) return false;
    return _.every(this.scaleHousePermissions, (permission) =>
      session.user.permissions.includes(permission)
    );
  }

  public isVisible(): boolean {
    return this.blackList.indexOf(this.currentUrl) === -1;
  }

  public toggleNav = (event) => {
    // if (this.expanded) {
    //   this.expanded = false;
    //   this.$adjustFlex.emit(false);
    // } else this.expanded = true;
    this.expanded = !this.expanded;
    this.$adjustFlex.emit(true);
  };
}
